import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminTaxonomyService {
  constructor() {
    this.endpoints = createPrefix('/admin/taxonomy', {
      timemachine: [
        '/timemachine',
        {
          scheduler: '/scheduler',
          date: '/date',
        },
      ],
    })
  }

  static create() {
    return new AdminTaxonomyService()
  }

  async getTimeMachineDates() {
    const servicePath = this.endpoints.timemachine.date()
    const { data } = await axios.get(servicePath)
    return data
  }

  async setTimeMachineCustomDate(date) {
    const servicePath = this.endpoints.timemachine.date()

    const { data } = await axios.put(
      servicePath,
      {},
      {
        params: {
          customDate: date,
        },
      }
    )

    return data
  }

  async isTimemachineSchedulerEnabled() {
    const servicePath = this.endpoints.timemachine.scheduler()
    const { data } = await axios.get(servicePath)
    return data
  }

  async setTimemachineSchedulerEnabled(enabled) {
    const servicePath = this.endpoints.timemachine.scheduler()
    const { data } = await axios.put(servicePath, {}, { params: { enabled } })
    return data
  }
}
